// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* a11y-dark theme for JavaScript, CSS, and HTML
* Based on the okaidia theme: https://github.com/PrismJS/prism/blob/gh-pages/themes/prism-okaidia.css
* @author ericwbailey
*/

.codeblock-dark code[class*="language-"],
.codeblock-dark pre[class*="language-"] {
  color: #f8f8f2;
  background: none;
  font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.65;

  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;

  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}

/* Code blocks */
.codeblock-dark pre[class*="language-"] {
  padding: 1em;
  margin: 0.5em 0;
  overflow: auto;
  border-radius: 0.3em;
}

.codeblock-dark :not(pre) > code[class*="language-"],
.codeblock-dark pre[class*="language-"] {
  background: #2b2b2b;
}

/* Inline code */
.codeblock-dark :not(pre) > code[class*="language-"] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}

.codeblock-dark .token.comment,
.codeblock-dark .token.prolog,
.codeblock-dark .token.doctype,
.codeblock-dark .token.cdata {
  color: #d4d0ab;
}

.codeblock-dark .token.punctuation {
  color: #fefefe;
}

.codeblock-dark .token.property,
.codeblock-dark .token.tag,
.codeblock-dark .token.constant,
.codeblock-dark .token.symbol,
.codeblock-dark .token.deleted {
  color: #ffa07a;
}

.codeblock-dark .token.boolean,
.codeblock-dark .token.number {
  color: #00e0e0;
}

.codeblock-dark .token.selector,
.codeblock-dark .token.attr-name,
.codeblock-dark .token.string,
.codeblock-dark .token.char,
.codeblock-dark .token.builtin,
.codeblock-dark .token.inserted {
  color: #abe338;
}

.codeblock-dark .token.operator,
.codeblock-dark .token.entity,
.codeblock-dark .token.url,
.codeblock-dark .language-css .token.string,
.codeblock-dark .style .token.string,
.codeblock-dark .token.variable {
  color: #00e0e0;
}

.codeblock-dark .token.atrule,
.codeblock-dark .token.attr-value,
.codeblock-dark .token.function {
  color: #ffd700;
}

.codeblock-dark .token.keyword {
  color: #00e0e0;
}

.codeblock-dark .token.regex,
.codeblock-dark .token.important {
  color: #ffd700;
}

.codeblock-dark .token.important,
.codeblock-dark .token.bold {
  font-weight: bold;
}

.codeblock-dark .token.italic {
  font-style: italic;
}

.codeblock-dark .token.entity {
  cursor: help;
}

@media screen and (-ms-high-contrast: active) {
  .codeblock-dark code[class*="language-"],
  .codeblock-dark pre[class*="language-"] {
    color: windowText;
    background: window;
  }

  .codeblock-dark :not(pre) > code[class*="language-"],
  .codeblock-dark pre[class*="language-"] {
    background: window;
  }

  .codeblock-dark .token.important {
    background: highlight;
    color: window;
    font-weight: normal;
  }

  .codeblock-dark .token.atrule,
  .codeblock-dark .token.attr-value,
  .codeblock-dark .token.function,
  .codeblock-dark .token.keyword,
  .codeblock-dark .token.operator,
  .codeblock-dark .token.selector {
    font-weight: bold;
  }

  .codeblock-dark .token.attr-value,
  .codeblock-dark .token.comment,
  .codeblock-dark .token.doctype,
  .codeblock-dark .token.function,
  .codeblock-dark .token.keyword,
  .codeblock-dark .token.operator,
  .codeblock-dark .token.property,
  .codeblock-dark .token.string {
    color: highlight;
  }

  .codeblock-dark .token.attr-value,
  .codeblock-dark .token.url {
    font-weight: normal;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/a11y-dark.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;;EAEE,cAAc;EACd,gBAAgB;EAChB,sEAAsE;EACtE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;;EAEjB,gBAAgB;EAChB,cAAc;EACd,WAAW;;EAEX,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,mBAAmB;EACrB;;EAEA;;;;;;IAME,iBAAiB;EACnB;;EAEA;;;;;;;;IAQE,gBAAgB;EAClB;;EAEA;;IAEE,mBAAmB;EACrB;AACF","sourcesContent":["/**\n* a11y-dark theme for JavaScript, CSS, and HTML\n* Based on the okaidia theme: https://github.com/PrismJS/prism/blob/gh-pages/themes/prism-okaidia.css\n* @author ericwbailey\n*/\n\n.codeblock-dark code[class*=\"language-\"],\n.codeblock-dark pre[class*=\"language-\"] {\n  color: #f8f8f2;\n  background: none;\n  font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  word-wrap: normal;\n  line-height: 1.65;\n\n  -moz-tab-size: 4;\n  -o-tab-size: 4;\n  tab-size: 4;\n\n  -webkit-hyphens: none;\n  -moz-hyphens: none;\n  -ms-hyphens: none;\n  hyphens: none;\n}\n\n/* Code blocks */\n.codeblock-dark pre[class*=\"language-\"] {\n  padding: 1em;\n  margin: 0.5em 0;\n  overflow: auto;\n  border-radius: 0.3em;\n}\n\n.codeblock-dark :not(pre) > code[class*=\"language-\"],\n.codeblock-dark pre[class*=\"language-\"] {\n  background: #2b2b2b;\n}\n\n/* Inline code */\n.codeblock-dark :not(pre) > code[class*=\"language-\"] {\n  padding: 0.1em;\n  border-radius: 0.3em;\n  white-space: normal;\n}\n\n.codeblock-dark .token.comment,\n.codeblock-dark .token.prolog,\n.codeblock-dark .token.doctype,\n.codeblock-dark .token.cdata {\n  color: #d4d0ab;\n}\n\n.codeblock-dark .token.punctuation {\n  color: #fefefe;\n}\n\n.codeblock-dark .token.property,\n.codeblock-dark .token.tag,\n.codeblock-dark .token.constant,\n.codeblock-dark .token.symbol,\n.codeblock-dark .token.deleted {\n  color: #ffa07a;\n}\n\n.codeblock-dark .token.boolean,\n.codeblock-dark .token.number {\n  color: #00e0e0;\n}\n\n.codeblock-dark .token.selector,\n.codeblock-dark .token.attr-name,\n.codeblock-dark .token.string,\n.codeblock-dark .token.char,\n.codeblock-dark .token.builtin,\n.codeblock-dark .token.inserted {\n  color: #abe338;\n}\n\n.codeblock-dark .token.operator,\n.codeblock-dark .token.entity,\n.codeblock-dark .token.url,\n.codeblock-dark .language-css .token.string,\n.codeblock-dark .style .token.string,\n.codeblock-dark .token.variable {\n  color: #00e0e0;\n}\n\n.codeblock-dark .token.atrule,\n.codeblock-dark .token.attr-value,\n.codeblock-dark .token.function {\n  color: #ffd700;\n}\n\n.codeblock-dark .token.keyword {\n  color: #00e0e0;\n}\n\n.codeblock-dark .token.regex,\n.codeblock-dark .token.important {\n  color: #ffd700;\n}\n\n.codeblock-dark .token.important,\n.codeblock-dark .token.bold {\n  font-weight: bold;\n}\n\n.codeblock-dark .token.italic {\n  font-style: italic;\n}\n\n.codeblock-dark .token.entity {\n  cursor: help;\n}\n\n@media screen and (-ms-high-contrast: active) {\n  .codeblock-dark code[class*=\"language-\"],\n  .codeblock-dark pre[class*=\"language-\"] {\n    color: windowText;\n    background: window;\n  }\n\n  .codeblock-dark :not(pre) > code[class*=\"language-\"],\n  .codeblock-dark pre[class*=\"language-\"] {\n    background: window;\n  }\n\n  .codeblock-dark .token.important {\n    background: highlight;\n    color: window;\n    font-weight: normal;\n  }\n\n  .codeblock-dark .token.atrule,\n  .codeblock-dark .token.attr-value,\n  .codeblock-dark .token.function,\n  .codeblock-dark .token.keyword,\n  .codeblock-dark .token.operator,\n  .codeblock-dark .token.selector {\n    font-weight: bold;\n  }\n\n  .codeblock-dark .token.attr-value,\n  .codeblock-dark .token.comment,\n  .codeblock-dark .token.doctype,\n  .codeblock-dark .token.function,\n  .codeblock-dark .token.keyword,\n  .codeblock-dark .token.operator,\n  .codeblock-dark .token.property,\n  .codeblock-dark .token.string {\n    color: highlight;\n  }\n\n  .codeblock-dark .token.attr-value,\n  .codeblock-dark .token.url {\n    font-weight: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
